import { createFileRoute } from '@tanstack/react-router';
import { VoterListDownloadPage } from '@/components/work-orders';

// A delivered voter list's link, emailed when it's ready. Open to whoever holds it, signed in or not.
export const Route = createFileRoute('/voter-list/$token')({
  component: VoterListRoute,
});

function VoterListRoute() {
  const { token } = Route.useParams();
  return <VoterListDownloadPage token={token} />;
}
